module.exports = __webpack_public_path__ + "img/herb-chives-350x184.e0f95d6a.jpg";